import React from 'react';
import '../../App.css';
import Hero from "../Hero";

function CoilyHair() {
    return (
        <>
          <h1> What is Coily Hair? </h1>
          <p> Also known as “Type 4,” coily hair is very volumnious and beautiful. 
              Type 4 develops its structure from the shape of the cortex. 
              The fibers of the hair are flat, and the flatter the hair shaft gets, 
              the more disulfide bonds occur between hair proteins, 
              making it squiggle in “s” and “z” shapes on the sides of the scalp. 
              Coily hair has strong hooks at the end of the follicle (bulb), 
              which keeps it from growing at an angle. In some cases, 
              hormones and certain medications can change the texture of the hair, 
              making it grow in a different way than originally formed.
          </p>
          </>
    );
}

export default CoilyHair;